module.exports = __webpack_public_path__ + "static/media/thx.f40f1245.jpg";